<template>
   <div id="smart_canvas" v-if="instanceRecid > 0">
      <!-- <div v-if="isLoadingInstance">
         <div class="loader-wrapper">
            <div class="loader">
            </div>
         </div>
      </div> -->
       <!-- Instance Controls -->
      <div id='inst_controls'>
         <div id='edit_title_container'>
            <input type='text' id='title' :value="instanceTitle" @focus="clearInput" @keyup="handleTitleChange"/>
         </div>
         <div id="save-options-wrapper" v-if="!locked">
            <!-- <div v-if="reviewing" @click="handleStageResponse(true)" class="approve action-btn green">Approve</div>
            <div v-if="reviewing" @click="handleStageResponse(false)" class="reject action-btn red">Reject</div> -->
            <a @click="handleSaveAsDraftClicked">SAVE AS DRAFT</a>
            <!-- <a @click="displayStageForApprovalModal">STAGE FOR REVIEW</a> -->
            <a v-if="editsMade" @click="handleResetClicked">RESET</a>
            <a v-if="instanceStatus == 1" @click="handleSaveAsClicked">SAVE AS</a>
            <a @click="handleSaveClicked">
               <div v-if="isSaving">
                  <div class="loader-wrapper">
                     <div class="loader">
                     </div>
                  </div>
               </div>
               <span v-else>SAVE</span>
            </a>
         </div>
      </div>

      <!-- Design Stage -->
      <div class="design-stage" id='ds_wrapper' :class="{global: isGlobal}">

         <!-- Rulers -->
         <ruler
            :range="1150"
            :position="'top'"
         ></ruler>

         <ruler 
            :range="1900"
            :position="'left'"
         ></ruler>

         <!-- Instance Container -->
         <div id="inst_container" class="design-container">

            <!-- Toolbox -->
            <toolbox
               v-if="!locked"
               :activateCrop="activeZoneType == 1"
               :activateMP="(activeZoneType > 0 && activeZoneType != 7) || (activeZoneType instanceof Array && activeZoneType.length > 1)"
               :activateColorWheel="activeZoneType == (7)"
               :activateOverlay="activeZoneType == 7"
               :activateMove="activeZoneType == 1"
               :moveActivated="moveImage > 0"
               :fullScreenActive="fullScreenActive"
               :mpOpen="mpOpen"
               :fixed="overlay"
               :bgColor="activeZone !== null && activeZone.style && activeZone.style.backgroundColor ? activeZone.style.backgroundColor : ''"
               @scale="handleScaleClick"
               @openMP="handleMPClick"
               @toggleCP="handleCPClick"
               @toggleMove="handleMoveClick"
               @toggleNotes="handleToggleNotesClick"
               @rotate="handleRotateClick"
               @flip="handleFlipClick"
               @notes="handleNotesClick"
               @fullScreen="handleFullScreenClick"
               @fontStyle="handleFontStyleClick"
               @textAlign="handleTextAlignClick"
               @preview="handlePreviewClick"
               @colorChange="handleColorChange"
            ></toolbox>

            <!-- <chrome-picker v-if="displayColorPicker" v-model="activeZone.style.backgroundColor" class="color-picker" @input="handleColorChange"/> -->

             <!-- Zone Container -->
            <div class="zone-container">
               <span class="zones-label">Zones:</span>
               <!-- <zone-button
                  :all="true"
                  :active="hiddenZones.length === 0"
                  @allToggle="handleZoneAllClick"
               >
               </zone-button> -->

               <zone-button
                  v-for="zone in sortedZones"
                  v-bind:key="zone.id"
                  :zoneId="zone.id"
                  :active="isZoneActive(zone)"
                  :isHidden="isZoneHidden(zone)"
                  :isHighlight="zone.id == activeZoneId"
                  @zoneToggle="handleZoneButtonClick"
               >
               </zone-button>

               <!-- <div v-if="isGlobal"
                  class="global-available"
                  @click="showAvailableChannelsMenu = !showAvailableChannelsMenu"
                  >
                  AVAILABLE GLOBAL CHANNELS
               </div>

               <available-channels-popup
                  v-if="showAvailableChannelsMenu && isGlobal"
                  :templateRecid="templateRecid"
                  :instanceRecid="instanceRecid"
                  :initialSelected="selectedChannels"
                  :channelSelections="globalChannels"
                  v-click-outside="hide"
                  @lastCheck="handleLastCheck">
               </available-channels-popup> -->
               
            </div>

            <div v-if="locked" class="locked-message-container">
               <div class="locked-message">
                  This instance is currently being edited by: <span class="text-white">{{editingInstanceUser}}</span>
               </div>
            </div>

            <!-- Canvas Container -->
            <div class="canvas-container">
         
               <div v-if="isLoadingInstance">
                  <div class="loader-wrapper">
                     <div class="loader">
                     </div>
                  </div>
               </div>

               <soccer-scoreboard-template v-else-if="instanceJson.tmpl && instanceJson.tmpl.id == 73">
               </soccer-scoreboard-template>

               <soccer-scoreboard-no-video-template v-else-if="instanceJson.tmpl && instanceJson.tmpl.id == 74">
               </soccer-scoreboard-no-video-template>

               <football-scoreboard-template v-else-if="instanceJson.tmpl && instanceJson.tmpl.id == 75">
               </football-scoreboard-template>

               <lacrosse-scoreboard-template v-else-if="instanceJson.tmpl && instanceJson.tmpl.id == 76">
               </lacrosse-scoreboard-template>

               <lacrosse-scoreboard-no-video-template v-else-if="instanceJson.tmpl && instanceJson.tmpl.id == 77">
               </lacrosse-scoreboard-no-video-template>

               <football-scoreboard-no-feed-template v-else-if="instanceJson.tmpl && instanceJson.tmpl.id == 82">
               </football-scoreboard-no-feed-template>

               <basketball-scoreboard-template v-else-if="instanceJson.tmpl && (instanceJson.tmpl.id == 87 || instanceJson.tmpl.id == 89)">
               </basketball-scoreboard-template>

               <volleyball-scoreboard-template v-else-if="instanceJson.tmpl && instanceJson.tmpl.id == 90">
               </volleyball-scoreboard-template>

               <base-template v-else-if="instanceJson.tmpl">
               </base-template>
            </div>

         </div>

      </div>

      <!-- Media Picker -->
      <transition name="slideleft">
         <media-picker 
            v-if="mediaPickerOpen"
            :channels="channels"
            :channelRecid="channelRecid" 
            :assetType="activeZone.type"
            :activeId="activeZone.id"
            :isScoreboard="false"
            :multiSelect="false"
         ></media-picker>
      </transition>

      <!-- Generic Error Modal -->
      <notify-modal
         v-if="notifyModal"
         :error="modalError"
         :subheadText="modalSubheadText"
         :message="modalMessage"
         :list="modalList"
      ></notify-modal>

      <!-- Action Modal -->
      <action-modal
         v-if="actionModal"
         :error="modalError"
         :subheadText="modalSubheadText"
         :message="modalMessage"
         :list="modalList"
         :actionType="modalActionType"
         @modalOk="handleModalOk"
      ></action-modal>

      <!-- Preview Overlay -->
      <preview-overlay
         v-if="preview"
         :json="instanceJson"
         :templateRecid="templateRecid"
         @close="handleClosePreview"
      ></preview-overlay>

      <!-- Unlock Block Admin Modal -->
      <unlock-block-modal
         v-if="unlockInstanceModal"
         :user="editingInstanceUser"
         :object="'Instance'"
         @unlock="handleBreakLock"
         @cancel="handleCloseUnlockModal">
      </unlock-block-modal>

      <error-message v-if="errorMessage" :message="errorMessage" />

   </div>
</template>

<script>
import BaseTemplate from './components/templates/BaseTemplate';
import Ruler from './components/Ruler';
import ZoneButton from './components/ZoneButton';
import AvailableChannelsPopup from './components/AvailableChannelsPopup';
import Toolbox from './components/Toolbox';
import PreviewOverlay from './components/PreviewOverlay';

import SoccerScoreboardTemplate from './components/templates/73/SoccerScoreboardTemplate';
import SoccerScoreboardNoVideoTemplate from './components/templates/74/SoccerScoreboardNoVideoTemplate';
import FootballScoreboardTemplate from './components/templates/75/FootballScoreboardTemplate';
import LacrosseScoreboardTemplate from './components/templates/76/LacrosseScoreboardTemplate';
import LacrosseScoreboardNoVideoTemplate from './components/templates/77/LacrosseScoreboardNoVideoTemplate';
import FootballScoreboardNoFeedTemplate from './components/templates/82/FootballScoreboardNoFeedTemplate';
import VolleyballScoreboardTemplate from './components/templates/90/VolleyballScoreboardTemplate';

import BasketballScoreboardTemplate from './components/templates/87/BasketballScoreboardTemplate';


import MediaPicker from '@/global/media_picker/MediaPicker';

import UnlockBlockModal from '@/global/modals/UnlockBlockModal';


import { EventBus } from '@/event-bus.js';
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
   data() {
      return {
         fullScreenActive: false
      }
   },

   created() {
      
      //TEMP
      // this.setInstRecid({instanceRecid: 2493, templateRecid: 87});
      EventBus.$on('new-instance-click', (recid, tempRecid, chanRecid, userRole) => {
         this.setInstRecid(
            {
               vm: this,
               instanceRecid: recid, 
               templateRecid: tempRecid, 
               channelRecid: chanRecid,
               userRole
            }
         );
      });

      EventBus.$once('destroy-sc', () => {
         this.resetSmartCanvas({vm: this});
         this.$destroy();
      });

      EventBus.$on('save-unsaved-changes', () => {
         this.saveInstance({vm: this, status: 1});
      });

      window.addEventListener('beforeunload', () => {
         if (this.instanceRecid > 0) {
            this.unlockInstance({vm:this});
         }
      });
   },

   updated: function () {
      this.$nextTick(function () {
         this.adjustZoneLabels();
      })
   },

   beforeDestroy() {
      EventBus.$off('new-instance-click');
      EventBus.$off('reset-sc');
      EventBus.$off('save-unsaved-changes');
   },

   computed: {
      ...mapState([
         'isLoadingInstance',
         'instanceRecid',
         'templateRecid',
         'channelRecid',
         'channels',
         'instanceTitle',
         'instanceJson',
         'instanceStatus',
         'allZones',
         'isGlobal',
         'currScene',
         'hiddenZones',
         'moveImage',
         'mpOpen',
         'overlay',
         'displayColorPicker',

         'activeZoneType',
         'activeZoneId',
         'activeZone',
         'zoneToAssetsDict',
         'editsMade',

         'isSaving',

         'preview',

         'unlockInstanceModal',
         'editingInstanceUser',

         'errorMessage',
         'locked',

         'uniqueTitleError'
      ]),

      ...mapState('global', [
         'mediaPickerOpen',
         'draggingAssetRecid',
         'draggingAssetType',
         'selectedAssets',
         'assignedAsset',
         'currentUser',

         //modal
         'notifyModal',
         'actionModal',
         'modalError',
         'modalSubheadText',
         'modalMessage',
         'modalList',
         'modalActionType'
      ]),

      sortedZones() {
         let sorted = this.allZones.sort(function(a,b) {
            let aOrder = parseInt(a.id);
            let bOrder = parseInt(b.id);

            if(aOrder < bOrder) return -1;
            if(aOrder > bOrder) return 1;
            return 0;
         });
         return sorted;
      }
   },

   methods: {
      ...mapActions([
         'fetchInstanceData',
         'saveInstance',
         'setInstRecid',
         'setActiveZone',
         'assignAsset',
         'toggleHideZone',
         'toggleAllZones',
         'changeZoneColor',
         'changeTitle',

         //Toolbox
         'toggleMediaPicker',
         'scaleImage',
         'rotateImage',
         'flipImage',
         'toggleMoveImage',
         'toggleColorPicker',
         'triggerPreview',
         'closePreview',

         'handleModalResponse',
         'handleUnsavedChanges',

         'displaySaveAsModal',
         'resetSmartCanvas',

         'breakInstanceLock',
         'closeUnlockModal',
         'breakLock',
         'unlockInstance'
      ]),

      ...mapActions('global', [
         'resetMP',
      ]),

      getInstance() {
         this.fetchInstanceData({vm: this});
      },

      handleTitleChange(e) {
         this.changeTitle({title: e.target.value});
      },

      handleSaveClicked() {
         this.saveInstance({vm: this, status: 1});
      },

      handleSaveAsDraftClicked() {
         this.saveInstance({vm: this, status: 10});
      },

      handleSaveAsClicked() {
         this.displaySaveAsModal();
      },

      handleResetClicked() {
         this.getInstance();
      },

      clearInput() {
         if (this.instanceTitle.startsWith('Untitled')) {
            this.instanceTitle = '';
         }
      },

      isZoneActive(zone) {
         if (this.instanceJson.tmpl && this.instanceJson.tmpl.scenes > 0) {
            return $.inArray(this.currScene, zone.scene) > -1;
         } else {
            return true;
         }
      },

      isZoneHidden(zone) {
         return $.inArray(zone.id, this.hiddenZones) > -1;
      },

      // handleZoneAllClick() {
      //    this.toggleAllZones();
      // },

      handleZoneButtonClick(hide, zoneId) {
         this.toggleHideZone({hide, zoneId});
      },

      handleColorChange(color) {
         this.changeZoneColor({color});
      },


      /* Toolbox Methods */
      handleScaleClick(direction) {
         this.scaleImage({direction});
      },

      handleRotateClick(direction) {
         this.rotateImage({direction});
      },

      handleFlipClick(direction) {
         this.flipImage({direction});
      },

      handleMPClick() {
         if ((this.activeZoneType > 0 && this.activeZoneType != 7) || (this.activeZoneType instanceof Array && this.activeZoneType.length > 1)) {
            this.toggleMediaPicker();
         }
      },

      handleCPClick() {
         this.toggleColorPicker();
      },

      handleMoveClick() {
         this.toggleMoveImage();
      },

      handleToggleNotesClick() {

      },

      handleNotesClick() {

      },

      handleFullScreenClick() {
         this.fullScreenActive = !this.fullScreenActive;
         EventBus.$emit('toggle-full-screen');
      },

      handleFontStyleClick() {

      },

      handleTextAlignClick() {

      },

      handlePreviewClick() {
         if (this.mediaPickerOpen) {
            this.toggleMediaPicker();
         }
         this.triggerPreview();
      },

      handleClosePreview() {
         this.closePreview();
      },

      handleModalOk(modalData) {
         this.handleModalResponse({vm: this, data: modalData});
      },

      handleBreakLock() {
         this.breakLock({vm: this, user: this.currentUser});
      },

      handleCloseUnlockModal() {
         this.closeUnlockModal();
      },

      adjustZoneLabels() {
         //loop through zone labels and if there are any that overlap
         //we need to adjust their positioning
         let zoneLabels = document.getElementsByClassName('zone-label');
         let prev = null;
         for (let label of zoneLabels) {
            if (prev !== null) {
               if (((prev.offsetLeft + prev.offsetWidth) > label.offsetLeft && label.offsetLeft >= prev.offsetLeft) && (prev.offsetTop === label.offsetTop)) {
                  label.style.left = (prev.offsetLeft + prev.offsetWidth + 15) + 'px';
               }
            }
            prev = label;
         }
      }
   },

   watch: {
      instanceRecid(newInstanceRecid, oldInstanceRecid) {
         if (this.instanceRecid > -1 && newInstanceRecid != oldInstanceRecid) {
            this.getInstance();
         }
      },

      activeZoneId() {
         //if not a text or color zone, open the media picker
         if (this.activeZoneType && this.activeZoneType != 7 && this.activeZone.val == '') {
            if (!this.mediaPickerOpen) {
               this.toggleMediaPicker();
            }
         } else if (this.activeZoneType && this.activeZoneType == 7) {
            if (this.mediaPickerOpen) {
               this.toggleMediaPicker();
            }
            this.toggleColorPicker();
         } else {
            if (this.mediaPickerOpen) {
               this.toggleMediaPicker();
            }
         }
      },

      assignedAsset() {
         if (this.assignedAsset != null && Object.entries(this.assignedAsset).length > 0) {
            this.assignAsset({vm: this, asset: this.assignedAsset});
         }
      },

      // uniqueTitleError() {
      //    if (this.uniqueTitleError) {
      //       $('#title').focus();
      //    }
      // },

      //we want to focus the title after we close the 
      //warning modal for a non-unique title
      errorMessage() {
         if (!this.errorMessage && this.uniqueTitleError) {
            $('#title').focus();
         }
      }
   },

   components: {
      BaseTemplate,
      Ruler,
      ZoneButton,
      AvailableChannelsPopup,
      Toolbox,
      PreviewOverlay,
      MediaPicker,

      SoccerScoreboardNoVideoTemplate,
      SoccerScoreboardTemplate,
      FootballScoreboardTemplate,
      LacrosseScoreboardNoVideoTemplate,
      FootballScoreboardNoFeedTemplate,
      LacrosseScoreboardTemplate,
      BasketballScoreboardTemplate,
      VolleyballScoreboardTemplate,

      UnlockBlockModal
   }
}
</script>

<style lang="scss">
@import "~bootstrap/scss/bootstrap";
// @import "./../assets/css/fonts";
// @import "./../assets/css/base";

#smart_canvas {
   width: 100%;
}

#inst_controls {
   width: 100%;
   display: flex;
   align-items: center;

   #edit_title_container {

      input[type='text'] {
         border-radius: 0;
         border: 0;
         background-color: transparent;
         font-size: 32px;
         font-weight: 600;
         color: #cacaca;
         box-shadow: none;

         &:focus {
            outline: 1px solid #b2b2b2;
         }
      }
   }

   #save-options-wrapper {
      color: #ffffff;
      display: flex;
      margin-left: auto;

      a {
         margin: 0 2px;
         padding: 2px 11px;
         border: 1px solid white;
         border-radius: .25em;
         font-size: .75rem;
         color: inherit;
         transition: all .25s ease;

         &:not(:last-child) {
            margin-right: 10px;
         }

         &:hover {
            outline: 0;
            border-color: #fff;
            background-color: #fff;
            color: #727479;
         }
      }

      .approve {
         color: white;
         background: green;
      }

      .reject {
         color: white;
         background: red;
      }
   }
}

.canvas-container {
   margin-top: 28px;
   padding-left: 15px;
}

.design-stage {
   margin-top: 4px;
   margin-bottom: 20px; 
   max-height: 825px;
   overflow: hidden;
   background-color: #fff;
   box-shadow: 0px 0px 6px 3px $bard-gold;

   &.global {
      box-shadow: 0px 0px 6px 3px $global-blue;
   }

   .design-container {
      margin: 0; 
      padding: 0;
      min-height: 800px;
      padding-left: 25px;
      position: relative;
      overflow-x: auto;
   }
}

.zone-container {
   display: flex;
   color: black;
   font-size: 12px;
   font-weight: bold;
   padding: 6px 10px;
   background: white;

   .zones-label {
      margin-right: 10px;
   }

   .global-available {
      color: $global-blue;
      margin-left: auto;
      margin-right: 75px;
      
      &:hover {
         cursor: pointer;
      }
   }
}

.color-picker {
   // position: absolute;
   // z-index: 999;
   // left: 500px;
   // top: 60px;
}

//color picker plugin
.vc-chrome {
   background: transparent !important;
   border: none !important;
   box-shadow: none !important;

   .vc-chrome-body {
      background: transparent !important;
   }

   .vc-input__input {
      background: transparent !important;
      color: white !important;
      box-shadow: none !important;
      border: 1px solid gray !important;
   }

   .vc-chrome-toggle-btn {
      display: none !important;
   }
}


.locked-message-container {
   background: #ff9320;
   display: inline-block;
   margin-left: 15px;
   margin-top: 10px;

   .locked-message {
      color: black;
      font-weight: bold;
      font-size: 14px;
      padding: .25em;

      // .text-white: {
      //    color: white;
      // }
   }
}
</style>